<button class="button"
        [attr.type]="type"
        [ngClass]="buttonClass"
        [disabled]="isDisabled"
        (click)="onClick.emit($event)">
    {{text}}
</button>
